import styled from 'styled-components'

const ShippingConditionLabel = styled.span`
  display: inline-flex;
  font-size: 80%;
`

export default ShippingConditionLabel
